import React from "react";
import { TicketTemplate } from "../../Templates/TicketTemplate";

export const Ticket = () => {
  return <TicketTemplate />;
};
